import React from "react";
import styled from "styled-components";
import { desktopWidth, drawerWidth } from "../AppBarAndDrawer/AppBarAndDrawer";

// MUI -> Arco migration reference pattern.
//
// makeStyles -> styled-components, with MUI theme values inlined (the Arco
// migration drops the MUI ThemeProvider): theme.spacing(4) = 32px. Structural MUI primitives with
// no Arco equivalent (here <Container maxWidth="xl">) become styled divs.

const Root = styled.div`
  display: flex;
`;

const Main = styled.main`
  flex-grow: 1;
  overflow: auto;
  /* Flex items default to min-width:auto, which refuses to shrink below their
     content's intrinsic width — a wide child (e.g. the Easy Email 3-column
     editor) would then blow the column past the viewport and shove the rest of
     the page off-screen. min-width:0 lets the column keep its width and scroll
     the overflow instead. */
  min-width: 0;
  @media (min-width: ${desktopWidth}px) {
    width: calc(100% - ${drawerWidth}px);
    margin-left: ${drawerWidth}px;
  }
`;

// Replaces <Container maxWidth="xl"> — a centered, max-width wrapper. 1920px is
// MUI's v4 "xl" breakpoint; the 16px horizontal padding matches Container's
// default gutters, the 32px vertical was the makeStyles `container` padding.
const Container = styled.div`
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 16px 8px;
  position: relative;
  @media (min-width: 600px) {
    padding: 32px 16px;
  }
`;

export default function Content({ children }) {
  return (
    <Root>
      <Main>
        <Container>{children}</Container>
      </Main>
    </Root>
  );
}
